import { render, staticRenderFns } from "./ModalLog.vue?vue&type=template&id=2e88752d&scoped=true&"
import script from "./ModalLog.vue?vue&type=script&lang=js&"
export * from "./ModalLog.vue?vue&type=script&lang=js&"
import style0 from "./ModalLog.vue?vue&type=style&index=0&id=2e88752d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88752d",
  null
  
)

export default component.exports